import { useTranslation } from 'react-i18next'
import { Button } from '@/components/v2/ui'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/v2/ui'
import type { BackendKeywords as BackendKeywordsType } from '@/lib/api/amazon-listing'

interface BackendKeywordsProps { data: BackendKeywordsType }

export function BackendKeywords({ data }: BackendKeywordsProps) {
  const { t } = useTranslation()
  const searchTerms = data.search_terms ?? ''
  if (!searchTerms.trim()) return null
  const byteCount = data.byte_count ?? 0
  const byteLimit = data.byte_limit && data.byte_limit > 0 ? data.byte_limit : 249
  const pct = Math.round((byteCount / byteLimit) * 100)
  const barColor = pct > 95 ? 'bg-red-500' : pct > 80 ? 'bg-yellow-500' : 'bg-green-500'

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm flex items-center justify-between">
          {t('optimizer.backendKeywords')}
          <Button variant="ghost" size="sm" onClick={() => navigator.clipboard.writeText(searchTerms)}>{t('optimizer.copy')}</Button>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <pre className="whitespace-pre-wrap text-sm font-mono bg-muted p-3 rounded-md">{searchTerms}</pre>
        <div>
          <div className="flex justify-between text-xs text-muted-foreground mb-1">
            <span>{byteCount}/{byteLimit} {t('optimizer.bytes')}</span>
            <span>{pct}%</span>
          </div>
          <div className="h-2 bg-muted rounded-full overflow-hidden">
            <div className={`h-full ${barColor} rounded-full`} style={{ width: `${Math.min(pct, 100)}%` }} />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
